export const TypesGate = {
    ATUALIZAR_GATE: "carregaDescarregaVolumeMercadoria/ATUALIZAR_GATE",
    ATUALIZAR_DETALHESGATE: "carregaDescarregaVolumeMercadoria/ATUALIZAR_DETALHESGATE",
    ATUALIZAR_DETALHESVOLUME: "carregaDescarregaVolumeMercadoria/ATUALIZAR_DETALHESVOLUME",
    ATUALIZAR_NODESGATE: "carregaDescarregaVolumeMercadoria/ATUALIZAR_NODESGATE",
    ATUALIZAR_IDNF: "carregaDescarregaVolumeMercadoria/ATUALIZAR_IDNF",
    ATUALIZAR_NODESNF: "carregaDescarregaVolumeMercadoria/ATUALIZAR_NODESNF",
    ATUALIZAR_NODESVOLUME: "carregaDescarregaVolumeMercadoria/ATUALIZAR_NODESVOLUME",
    ATUALIZAR_EMPILHADEIRAS: "carregaDescarregaVolumeMercadoria/ATUALIZAR_EMPILHADEIRAS",
    ATUALIZAR_LOCALIDADES: "carregaDescarregaVolumeMercadoria/ATUALIZAR_LOCALIDADES",
    ATUALIZAR_EMBALAGENS: "carregaDescarregaVolumeMercadoria/ATUALIZAR_EMBALAGENS",
    ATUALIZAR_VOLUMEID: "carregaDescarregaVolumeMercadoria/ATUALIZAR_VOLUMEID",
    ATUALIZAR_LOTEALTERACAO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_LOTEALTERACAO",
    ATUALIZAR_BOARDTOP: "carregaDescarregaVolumeMercadoria/ATUALIZAR_BOARDTOP",
    ATUALIZAR_BOARDBOTTOM: "carregaDescarregaVolumeMercadoria/ATUALIZAR_BOARDBOTTOM",
    ATUALIZAR_PROGRAMACAOID: "carregaDescarregaVolumeMercadoria/ATUALIZAR_PROGRAMACAOID",
    ATUALIZAR_ITENSCHECKLISTPEACAO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_ITENSCHECKLISTPEACAO",
    ATUALIZAR_CHECKLISTPEACAO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_CHECKLISTPEACAO",
    ATUALIZAR_ITENSCHECKLISTPEACAODESOVA: "carregaDescarregaVolumeMercadoria/ATUALIZAR_ITENSCHECKLISTPEACAODESOVA",
    ATUALIZAR_CHECKLISTPEACAODESOVA: "carregaDescarregaVolumeMercadoria/ATUALIZAR_CHECKLISTPEACAODESOVA",
    ATUALIZAR_CODIGOPRODUTO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_CODIGOPRODUTO",
    ATUALIZAR_NFDADOSPRODUTO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_NFDADOSPRODUTO",
    ATUALIZAR_CARREGAMENTO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_CARREGAMENTO",
    ATUALIZAR_DESCARGA: "carregaDescarregaVolumeMercadoria/ATUALIZAR_DESCARGA",
    ATUALIZAR_MERCADORIA: "carregaDescarregaVolumeMercadoria/ATUALIZAR_MERCADORIA",
    ATUALIZAR_MERCADORIAREADONLY: "carregaDescarregaVolumeMercadoria/ATUALIZAR_MERCADORIAREADONLY",
    ATUALIZAR_SKILLSFUNCIONARIO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_SKILLSFUNCIONARIO",
    ATUALIZAR_TELAPEACAO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_TELAPEACAO",
    ATUALIZAR_ACRESCIMO: "carregaDescarregaVolumeMercadoria/ATUALIZAR_ACRESCIMO",
    ATUALIZAR_DESOVA: 'carregaDescarregaVolumeMercadoria/ATUALIZAR_DESOVA',
    ATUALIZAR_FINALIZAR_DESOVA: 'carregaDescarregaVolumeMercadoria/ATUALIZAR_FINALIZAR_DESOVA',
    ATUALIZAR_COMBOS_AVARIAS: 'carregaDescarregaVolumeMercadoria/ATUALIZAR_COMBOS_AVARIAS',
    AVARIA_LOCAL_CHECKED: 'carregaDescarregaVolumeMercadoria/AVARIA_LOCAL_CHECKED',
    AVARIA_COMPLEMENTO_CHECKED: 'carregaDescarregaVolumeMercadoria/AVARIA_COMPLEMENTO_CHECKED',
    AVARIA_PROVIDENCIA_CHECKED: 'carregaDescarregaVolumeMercadoria/AVARIA_PROVIDENCIA_CHECKED',
    AVARIA_REMOVER_CHECKED: 'carregaDescarregaVolumeMercadoria/AVARIA_REMOVER_CHECKED',
    AVARIA_TIPO_CHECKED: 'carregaDescarregaVolumeMercadoria/AVARIA_TIPO_CHECKED',
    AVARIA_PESO: 'carregaDescarregaVolumeMercadoria/AVARIA_PESO',
    SET_AVARIAS: 'carregaDescarregaVolumeMercadoria/SET_AVARIAS',
    REMOVE_AVARIAS: 'carregaDescarregaVolumeMercadoria/REMOVE_AVARIAS',
    RESET_AVARIAS: 'carregaDescarregaVolumeMercadoria/RESET_AVARIAS',
    RESET_CARREGAMENTO: "carregaDescarregaVolumeMercadoria/RESET_CARREGAMENTO",
    RESET_CHECKLISTPEACAO: "carregaDescarregaVolumeMercadoria/RESET_CHECKLISTPEACAO",
    RESET_DESCARGA: "carregaDescarregaVolumeMercadoria/RESET_DESCARGA",
    RESET_MERCADORIA: "carregaDescarregaVolumeMercadoria/RESET_MERCADORIA",
    RESET_ACRESCIMO: "carregaDescarregaVolumeMercadoria/RESET_ACRESCIMO",
    RESET_STATE: "carregaDescarregaVolumeMercadoria/RESET_STATE",
    RESET_DESOVA: "carregaDescarregaVolumeMercadoria/RESET_DESOVA",
    RESET_FINALIZAR_DESOVA: "carregaDescarregaVolumeMercadoria/RESET_FINALIZAR_DESOVA"
}

/**@type {import("./useCarregaDescarregaVolumeMercadoria").CarregaDescarregaVolumeMercadoria['state']} */
const INITIAL = {
    gate: {
        Classe: 0,
        Descricao: "",
        Icon: 0,
        IconColor: "",
        IconNome: "",
        Id: 0,
        IniciaDescarrega: false,
        Interrompido: false,
        MsgConfirm: "",
        OperacaoTipo: "",
        URL: ""
    },
    carregamento: {
        volume: "",
        lote: "",
        mercadoriaLocalId: undefined,
        empilhadeiraSelecionada: undefined,
        operacao: undefined,
        tipo: '',
        listaAjudantes: [],
        ajudantes: [],
        etiqueta: ""
    },
    desova: {
        title: '',
        passagemId: undefined,
        loteId: undefined,
        volume: undefined,
        lacreContainer: 'SL',
        empilhadeiras: [],
        embalagens: [],
        tipo: undefined,
        embalagem: undefined,
        descricaoEmbalagem: '',
        quantidadeRegular: undefined,
        embalagemRegular: undefined,
        peso: undefined,
        descricaoEmbalagemRegular: '',
        embalagemSelecionada: undefined,
        empilhadeira: undefined,
        TiposAvaria: [],
        LocaisAvaria: [],
        ComplementosAvaria: [],
        ProvidenciasAvaria: [],
        Avarias: [],
        avariaLocalChecked: [],
        avariaTipoChecked: [],
        avariaComplementoChecked: [],
        avariaProvidenciaChecked: [],
        avariaRemoverChecked: [],
        avariaPeso: 0,
        itensCheckListPeacao: [],
        checkListPeacao: []
    },
    finalizarDesova: {
        condicaoContainer: 1,
        tipoOperacao: undefined,
        lacreMarimex: '',
        vistoriaFina: -1,
        ajudantes: [],
        listaAjudantes: [],
        divergencias: '',
        observacao: ''
    },
    descarga: {
        volume: "",
        tipoVolume: undefined,
        embalagemSelecionada: undefined,
        embalagemRegularSelecionada: undefined,
        quantidadeRegular: undefined,
        contraMarca: "",
        comprimento: "",
        largura: "",
        altura: "",
        peso: "",
        localidadeSelecionada: undefined,
        empilhadeiraSelecionada: undefined,
        operacao: undefined,
        descricaoVolume: "",
        lote: 0,
        listaAjudantes: [],
        ajudantes: [],
        labelLocal: '',
        localidades: [],
        localidade: 0,
        descricaoLocalidade: '',
        localidadePaiId: 0,
        localidadeObjeto: {},
        etiqueta: ""
    },
    mercadoria: {
        MerQtde: undefined,
        MerFabricacao: "",
        MerAdmissao: "",
        MerReferencia: "",
        MerVencimento: ""
    },
    telaPeacao: {
        exibe: false,
        tipo: 1,
        mostraOpcoes: false,
        executeAfterFinish: undefined,
        carregamento: false
    },
    acrescimo: {
        qtde: null,
        descricao: '',
        embalagem: -1,
        marca: '',
        onu: '',
        peso: null
    },
    mercadoriaReadOnly: {},
    localidades: [],
    embalagens: [],
    itensCheckListPeacao: [],
    checkListPeacao: [],
    detalhesGate: {},
    detalhesVolume: '',
    nodesGate: [],
    idNf: 0,
    nodesNf: [],
    nodesVolume: [],
    empilhadeiras: [],
    volumeId: "",
    boardTop: "",
    boardBottom: [],
    programacaoId: 0,
    codigoProduto: "",
    idNFDadosProduto: 0,
    skillsFuncionario: [],
    loteAlteracao: 0
}

export default function carregaDescarregaVolumeMercadoriaReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesGate.ATUALIZAR_SKILLSFUNCIONARIO:
            return {
                ...state,
                skillsFuncionario: action.payload.skillsFuncionario
            }
        case TypesGate.ATUALIZAR_GATE:
            return {
                ...state,
                gate: action.payload.gate
            };
        case TypesGate.ATUALIZAR_DETALHESGATE:
            return {
                ...state,
                detalhesGate: action.payload.detalhesGate
            };
        case TypesGate.ATUALIZAR_DETALHESVOLUME:
            return {
                ...state,
                detalhesVolume: action.payload.detalhesVolume
            }
        case TypesGate.ATUALIZAR_NODESGATE:
            return {
                ...state,
                nodesGate: action.payload.nodesGate
            };
        case TypesGate.ATUALIZAR_IDNF:
            return {
                ...state,
                idNf: action.payload.idNf
            };
        case TypesGate.ATUALIZAR_NODESNF:
            return {
                ...state,
                nodesNf: action.payload.nodesNf
            };
        case TypesGate.ATUALIZAR_NODESVOLUME:
            return {
                ...state,
                nodesVolume: action.payload.nodesVolume
            };
        case TypesGate.ATUALIZAR_EMPILHADEIRAS:
            return {
                ...state,
                empilhadeiras: action.payload.empilhadeiras
            };
        case TypesGate.ATUALIZAR_VOLUMEID:
            return {
                ...state,
                volumeId: action.payload.volumeId
            };
        case TypesGate.ATUALIZAR_LOTEALTERACAO:
            return {
                ...state,
                loteAlteracao: action.payload.loteAlteracao
            }
        case TypesGate.ATUALIZAR_LOCALIDADES:
            return {
                ...state,
                localidades: action.payload.arr
            }
        case TypesGate.ATUALIZAR_EMBALAGENS:
            return {
                ...state,
                embalagens: action.payload.arr
            }
        case TypesGate.ATUALIZAR_BOARDTOP:
            return {
                ...state,
                boardTop: action.payload.boardTop
            };
        case TypesGate.ATUALIZAR_BOARDBOTTOM:
            return {
                ...state,
                boardBottom: action.payload.boardBottom
            };
        case TypesGate.ATUALIZAR_PROGRAMACAOID:
            return {
                ...state,
                programacaoId: action.payload.programacaoId
            };
        case TypesGate.ATUALIZAR_ITENSCHECKLISTPEACAO:
            return {
                ...state,
                itensCheckListPeacao: action.payload.itensCheckListPeacao
            };
        case TypesGate.ATUALIZAR_CHECKLISTPEACAO:
            let objCheckListPeacao = state.checkListPeacao.slice();
            let item = {};

            if (action.payload.obj.Valor < 0 || action.payload.obj.Valor === undefined)
                return {
                    ...state
                };

            if (state.checkListPeacao.length > 0) {

                item = objCheckListPeacao.find((element) =>
                    element.Id === action.payload.obj.Id
                );

                if (item !== undefined)
                    item.Valor = action.payload.obj.Valor;
                else
                    objCheckListPeacao.push(action.payload.obj);

            }

            if (state.checkListPeacao.length <= 0)
                objCheckListPeacao.push(action.payload.obj);

            return {
                ...state,
                checkListPeacao: JSON.stringify(action.payload.obj).at(0) === '{' ? objCheckListPeacao : action.payload.obj
            };

        case TypesGate.ATUALIZAR_ITENSCHECKLISTPEACAODESOVA:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    itensCheckListPeacao: action.payload.itensCheckListPeacao
                }
            };
        case TypesGate.ATUALIZAR_CHECKLISTPEACAODESOVA:

            let objCheckListPeacaoDesova = state.desova.checkListPeacao.slice();
            let itemDesova = {};

            if (action.payload.obj.Valor < 0 || action.payload.obj.Valor === undefined)
                return {
                    ...state
                };

            if (state.desova.checkListPeacao.length > 0) {

                itemDesova = objCheckListPeacaoDesova.find((element) =>
                    element.Id === action.payload.obj.Id
                );

                if (itemDesova !== undefined)
                    itemDesova.Valor = action.payload.obj.Valor;
                else
                    objCheckListPeacaoDesova.push(action.payload.obj);

            }

            if (state.desova.checkListPeacao.length <= 0)
                objCheckListPeacaoDesova.push(action.payload.obj);

            return {
                ...state,
                checkListPeacao: JSON.stringify(action.payload.obj).at(0) === '{' ? objCheckListPeacaoDesova : action.payload.obj
            };
        case TypesGate.ATUALIZAR_CODIGOPRODUTO:
            return {
                ...state,
                codigoProduto: action.payload.codigo
            }
        case TypesGate.ATUALIZAR_NFDADOSPRODUTO:
            return {
                ...state,
                idNFDadosProduto: action.payload.id
            }
        case TypesGate.ATUALIZAR_MERCADORIAREADONLY:
            return {
                ...state,
                mercadoriaReadOnly: action.payload.mercadoriaReadOnly
            }
        case TypesGate.ATUALIZAR_CARREGAMENTO:
            let carregamentoNew = {};

            Object.assign(carregamentoNew, state.carregamento);

            carregamentoNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                carregamento: carregamentoNew
            }
        case TypesGate.ATUALIZAR_DESCARGA:

            let descargaNew = {};

            Object.assign(descargaNew, state.descarga);

            descargaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                descarga: descargaNew
            }
        case TypesGate.ATUALIZAR_MERCADORIA:

            let mercadoriaNew = {};

            Object.assign(mercadoriaNew, state.mercadoria);

            mercadoriaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                mercadoria: mercadoriaNew
            }
        case TypesGate.ATUALIZAR_ACRESCIMO:

            let acrescimoNew = {};

            Object.assign(acrescimoNew, state.acrescimo);

            acrescimoNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                acrescimo: acrescimoNew
            }
        case TypesGate.ATUALIZAR_TELAPEACAO:
            return {
                ...state,
                telaPeacao: action.payload.telaPeacao
            }
        case TypesGate.ATUALIZAR_DESOVA:
            let desovaNew = {};

            Object.assign(desovaNew, state.desova);

            desovaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                desova: desovaNew
            }
        case TypesGate.ATUALIZAR_FINALIZAR_DESOVA:
            let finalizarDesovaNew = {};

            Object.assign(finalizarDesovaNew, state.finalizarDesova);

            finalizarDesovaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                finalizarDesova: finalizarDesovaNew
            }
        case TypesGate.ATUALIZAR_COMBOS_AVARIAS:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    TiposAvaria: action.payload.Tipos,
                    LocaisAvaria: action.payload.Locais,
                    ComplementosAvaria: action.payload.Complementos,
                    ProvidenciasAvaria: action.payload.Providencias
                }
            };
        case TypesGate.AVARIA_LOCAL_CHECKED:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaLocalChecked: action.payload
                }
            };
        case TypesGate.AVARIA_COMPLEMENTO_CHECKED:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaComplementoChecked: action.payload
                }
            };
        case TypesGate.AVARIA_PROVIDENCIA_CHECKED:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaProvidenciaChecked: action.payload
                }
            }
        case TypesGate.AVARIA_REMOVER_CHECKED:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaRemoverChecked: action.payload
                }
            };
        case TypesGate.AVARIA_TIPO_CHECKED:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaTipoChecked: action.payload
                }
            };
        case TypesGate.AVARIA_PESO:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    avariaPeso: action.payload
                }
            }
        case TypesGate.SET_AVARIAS:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    Avarias: action.payload
                }
            };
        case TypesGate.REMOVE_AVARIAS:
            return ({
                ...state,
                desova: {
                    ...state.desova,
                    Avarias: [...state.desova.Avarias.filter(function (a, index) { return !state.desova.avariaRemoverChecked.includes(index) })]
                }
            })
        case TypesGate.RESET_AVARIAS:
            return {
                ...state,
                desova: {
                    ...state.desova,
                    TiposAvaria: [],
                    LocaisAvaria: [],
                    ComplementosAvaria: [],
                    ProvidenciasAvaria: [],
                    Avarias: [],
                    avariaLocalChecked: [],
                    avariaTipoChecked: [],
                    avariaComplementoChecked: [],
                    avariaProvidenciaChecked: [],
                    avariaRemoverChecked: [],
                    avariaPeso: 0
                }
            }
        case TypesGate.RESET_CARREGAMENTO:
            return {
                ...state,
                carregamento: INITIAL.carregamento
            }
        case TypesGate.RESET_DESCARGA:
            return {
                ...state,
                descarga: INITIAL.descarga
            }
        case TypesGate.RESET_MERCADORIA:
            return {
                ...state,
                mercadoria: INITIAL.mercadoria
            }
        case TypesGate.RESET_CHECKLISTPEACAO:
            return {
                ...state,
                checkListPeacao: INITIAL.checkListPeacao
            }
        case TypesGate.RESET_ACRESCIMO:
            return {
                ...state,
                acrescimo: INITIAL.acrescimo
            }
        case TypesGate.RESET_DESOVA:
            return {
                ...state,
                desova: INITIAL.desova
            }
        case TypesGate.RESET_FINALIZAR_DESOVA:
            return {
                ...state,
                finalizarDesova: INITIAL.finalizarDesova
            }
        case TypesGate.RESET_STATE:
            return INITIAL;
        default:
            return state;
    }
}

export const CarregaDescarregaVolumeMercadoriaActions = {
    setGate,
    setDetalhesGate,
    setDetalhesVolume,
    setNodesGate,
    setIdNf,
    setNodesNf,
    setNodesVolume,
    setEmpilhadeiras,
    setLocalidades,
    setEmbalagens,
    setVolumeId,
    setLoteAlteracao,
    setBoardTop,
    setBoardBottom,
    setProgramacaoId,
    setItensCheckListPeacao,
    setCheckListPeacao,
    setItensCheckListPeacaoDesova,
    setCheckListPeacaoDesova,
    setCodigoProduto,
    setIdNFDadosProduto,
    setMercadoriaReadOnly,
    setCarregamento,
    setDescarga,
    setMercadoria,
    setSkillsFuncionario,
    setTelaPeacao,
    setAcrescimo,
    setDesova,
    setFinalizarDesova,
    setCombosAvarias,
    avariaLocalChecked,
    avariaComplementoChecked,
    avariaProvidenciaChecked,
    avariaRemoverChecked,
    avariaTipoChecked,
    avariaPeso,
    setAvarias,
    deletarAvarias,
    resetAvarias,
    resetCarregamento,
    resetDescarga,
    resetMercadoria,
    resetChecklistPeacao,
    resetAcrescimo,
    resetState,
    resetDesova,
    resetFinalizarDesova
}

function setSkillsFuncionario(skillsFuncionario) {
    return {
        type: TypesGate.ATUALIZAR_SKILLSFUNCIONARIO,
        payload: { skillsFuncionario: skillsFuncionario }
    }
}

function setGate(gate) {
    return {
        type: TypesGate.ATUALIZAR_GATE,
        payload: { gate: gate }
    }
}

function setDetalhesGate(detalhesGate) {
    return {
        type: TypesGate.ATUALIZAR_DETALHESGATE,
        payload: { detalhesGate: detalhesGate }
    }
}

function setDetalhesVolume(detalhesVolume) {
    return {
        type: TypesGate.ATUALIZAR_DETALHESVOLUME,
        payload: { detalhesVolume: detalhesVolume }
    }
}

function setNodesGate(nodesGate) {
    return {
        type: TypesGate.ATUALIZAR_NODESGATE,
        payload: { nodesGate: nodesGate }
    }
}

function setIdNf(id) {
    return {
        type: TypesGate.ATUALIZAR_IDNF,
        payload: { idNf: id }
    }
}

function setNodesNf(nodesNf) {
    return {
        type: TypesGate.ATUALIZAR_NODESNF,
        payload: { nodesNf: nodesNf }
    }
}

function setNodesVolume(nodesVolume) {
    return {
        type: TypesGate.ATUALIZAR_NODESVOLUME,
        payload: { nodesVolume: nodesVolume }
    }
}

function setEmpilhadeiras(empilhadeiras) {
    return {
        type: TypesGate.ATUALIZAR_EMPILHADEIRAS,
        payload: { empilhadeiras: empilhadeiras }
    }
}

function setLocalidades(arr) {
    return {
        type: TypesGate.ATUALIZAR_LOCALIDADES,
        payload: { arr: arr }
    }
}

function setEmbalagens(arr) {
    return {
        type: TypesGate.ATUALIZAR_EMBALAGENS,
        payload: { arr: arr }
    }
}

function setVolumeId(volumeId) {
    return {
        type: TypesGate.ATUALIZAR_VOLUMEID,
        payload: { volumeId: volumeId }
    }
}

function setLoteAlteracao(loteAlteracao) {
    return {
        type: TypesGate.ATUALIZAR_LOTEALTERACAO,
        payload: { loteAlteracao: loteAlteracao }
    }
}

function setBoardTop(boardTop) {
    return {
        type: TypesGate.ATUALIZAR_BOARDTOP,
        payload: { boardTop: boardTop }
    }
}

function setBoardBottom(boardBottom) {
    return {
        type: TypesGate.ATUALIZAR_BOARDBOTTOM,
        payload: { boardBottom: boardBottom }
    }
}

function setProgramacaoId(id) {
    return {
        type: TypesGate.ATUALIZAR_PROGRAMACAOID,
        payload: { programacaoId: id }
    }
}

function setItensCheckListPeacao(itensCheckListPeacao) {
    return {
        type: TypesGate.ATUALIZAR_ITENSCHECKLISTPEACAO,
        payload: { itensCheckListPeacao: itensCheckListPeacao }
    }
}

function setCheckListPeacao(obj) {
    return {
        type: TypesGate.ATUALIZAR_CHECKLISTPEACAO,
        payload: { obj: obj }
    }
}

function setItensCheckListPeacaoDesova(itensCheckListPeacao) {
    return {
        type: TypesGate.ATUALIZAR_ITENSCHECKLISTPEACAODESOVA,
        payload: { itensCheckListPeacao: itensCheckListPeacao }
    }
}

function setCheckListPeacaoDesova(obj) {
    return {
        type: TypesGate.ATUALIZAR_CHECKLISTPEACAODESOVA,
        payload: { obj: obj }
    }
}

function setCodigoProduto(codigo) {
    return {
        type: TypesGate.ATUALIZAR_CODIGOPRODUTO,
        payload: { codigo: codigo }
    }
}

function setIdNFDadosProduto(id) {
    return {
        type: TypesGate.ATUALIZAR_NFDADOSPRODUTO,
        payload: { id: id }
    }
}

function setCarregamento(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_CARREGAMENTO,
        payload: { valor: valor, campo: campo }
    }
}

function setDescarga(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_DESCARGA,
        payload: { valor: valor, campo: campo }
    }
}

function setMercadoria(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_MERCADORIA,
        payload: { valor: valor, campo: campo }
    }
}

function setAcrescimo(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_ACRESCIMO,
        payload: { valor: valor, campo: campo }
    }
}

function setTelaPeacao(exibe, tipo, mostraOpcoes, executeAfterFinish, carregamento) {
    return {
        type: TypesGate.ATUALIZAR_TELAPEACAO,
        payload: { telaPeacao: { exibe: exibe, tipo: tipo, mostraOpcoes: mostraOpcoes, executeAfterFinish: executeAfterFinish, carregamento: carregamento } }
    }
}

function setDesova(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_DESOVA,
        payload: { valor: valor, campo: campo }
    }
}

function setFinalizarDesova(valor, campo) {
    return {
        type: TypesGate.ATUALIZAR_FINALIZAR_DESOVA,
        payload: { valor: valor, campo: campo }
    }
}

function setCombosAvarias(dadosAvarias) {
    return {
        type: TypesGate.ATUALIZAR_COMBOS_AVARIAS,
        payload: dadosAvarias
    }
}

function avariaLocalChecked(checked) {
    return {
        type: TypesGate.AVARIA_LOCAL_CHECKED,
        payload: checked
    }
}

function avariaComplementoChecked(checked) {
    return {
        type: TypesGate.AVARIA_COMPLEMENTO_CHECKED,
        payload: checked
    }
}

function avariaProvidenciaChecked(checked) {
    return {
        type: TypesGate.AVARIA_PROVIDENCIA_CHECKED,
        payload: checked
    }
}

function avariaRemoverChecked(checked) {
    return {
        type: TypesGate.AVARIA_REMOVER_CHECKED,
        payload: checked
    }
}

function avariaTipoChecked(checked) {
    return {
        type: TypesGate.AVARIA_TIPO_CHECKED,
        payload: checked
    }
}

function avariaPeso(peso) {
    return {
        type: TypesGate.AVARIA_PESO,
        payload: peso
    }
}

function setAvarias(dadosAvarias) {
    return {
        type: TypesGate.SET_AVARIAS,
        payload: dadosAvarias
    }
}

function deletarAvarias() {
    return { type: TypesGate.REMOVE_AVARIAS }
}

function resetAvarias() {
    return { type: TypesGate.RESET_AVARIAS }
}

function resetCarregamento() {
    return { type: TypesGate.RESET_CARREGAMENTO }
}

function resetDescarga() {
    return { type: TypesGate.RESET_DESCARGA }
}

function resetMercadoria() {
    return { type: TypesGate.RESET_MERCADORIA }
}

function resetChecklistPeacao() {
    return { type: TypesGate.RESET_CHECKLISTPEACAO }
}

function setMercadoriaReadOnly(mercadoriaReadOnly) {
    return {
        type: TypesGate.ATUALIZAR_MERCADORIAREADONLY,
        payload: { mercadoriaReadOnly: mercadoriaReadOnly }
    }
}

function resetAcrescimo() {
    return { type: TypesGate.RESET_ACRESCIMO }
}

function resetState() {
    return { type: TypesGate.RESET_STATE }
}

function resetDesova() {
    return { type: TypesGate.RESET_DESOVA }
}

function resetFinalizarDesova() {
    return { type: TypesGate.RESET_FINALIZAR_DESOVA }
}